import { render, staticRenderFns } from "./InvitaionAccepted.vue?vue&type=template&id=50dcbb49&scoped=true"
import script from "./InvitaionAccepted.vue?vue&type=script&lang=js"
export * from "./InvitaionAccepted.vue?vue&type=script&lang=js"
import style0 from "./InvitaionAccepted.vue?vue&type=style&index=0&id=50dcbb49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcbb49",
  null
  
)

export default component.exports